import React, { useState } from "react";
import { Expand } from "lucide-react";
import { beforeAfterData } from "../../data/mockData";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";

// Same footprint as service cards: lg 4-up, md 2-up, h-56, rounded-2xl
const tileWidth = "w-full md:w-[calc(50%-1rem)] lg:w-[calc(25%-1.5rem)]";

const BeforeAfterTile = ({ img, onOpen }) => (
  <button
    type="button"
    onClick={() => onOpen(img)}
    aria-label={`View full image: ${img.alt}`}
    data-testid={`before-after-tile-${img.id}`}
    className={`${tileWidth} group relative h-56 overflow-hidden rounded-2xl border-2 border-slate-100 bg-white shadow-lg transition-all duration-300 hover:border-cleanora-primary/30 hover:shadow-2xl`}
  >
    <img
      alt={img.alt}
      src={img.src}
      loading="lazy"
      className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
    />
    <span className="absolute bottom-3 right-3 flex h-9 w-9 items-center justify-center rounded-full bg-white/90 text-slate-700 opacity-0 shadow transition-opacity duration-300 group-hover:opacity-100 group-focus-visible:opacity-100">
      <Expand className="h-4 w-4" />
    </span>
  </button>
);

const BeforeAfterSection = () => {
  const [open, setOpen] = useState(null);

  return (
    <section className="py-20 bg-gradient-to-br from-sky-50 to-white" data-testid="before-after-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            {beforeAfterData.title}
          </h3>
          <p className="text-lg text-slate-600">{beforeAfterData.subtitle}</p>
        </div>

        <div className="flex flex-wrap justify-center gap-8">
          {beforeAfterData.images.map((img) => (
            <BeforeAfterTile key={img.id} img={img} onOpen={setOpen} />
          ))}
        </div>
        <p className="mt-6 text-center text-sm text-slate-500">Tap any photo to see the full before and after.</p>
      </div>

      <Dialog open={!!open} onOpenChange={(v) => !v && setOpen(null)}>
        <DialogContent className="max-w-5xl border-0 bg-transparent p-0 shadow-none" data-testid="before-after-dialog">
          <DialogTitle className="sr-only">{open?.alt}</DialogTitle>
          {open && <img src={open.src} alt={open.alt} className="max-h-[85vh] w-full rounded-2xl object-contain" />}
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default BeforeAfterSection;
